import TransporterAnalyticsEvent from "./class.TransporterAnalyticsEvent";
import TransporterLog from "../class.TransporterLog.js";

const LOGGER = new TransporterLog({
	attributes: {
		name: "TransporterAnalyticsTrial",
		color: "lime",
	},
});

const ALIAS = {
	GET_ID: "transporter_analytics_trial_get_id",
	UPDATE: "transporter_analytics_trial_update",
};

export default class TransporterAnalyticsTrial extends TransporterAnalyticsEvent {
	constructor(options) {
		super(options);
		this.trial_id = null;
		this.initialize();
	}

	initialize() {
		const error = _.bind(LOGGER.error, LOGGER);
		LOGGER.error = (...n) => {
			if (this.controller.isEnabled()) {
				this.controller.incrementErrorCount();
				error(...n);
			}
		};

		if (!_.isNumber(this.trial_id)) {
			this.idPromise = this.getId();
		}
	}

	async getId() {
		if (this.trial_id) {
			return this.trial_id;
		} else if (this.idPromise) {
			const id = await this.idPromise;
			return id;
		}
		const {
			item,
			attempt,
			passed_at,
			failed_at,
			gave_up_at,
			requested_hint_at,
			response,
			last_hint,
		} = this;
		try {
			const id = await this.controller.enqueue(ALIAS.GET_ID, {
				item_id: await item.getId(),
				attempt: attempt || 0,
				passed_at: passed_at || null,
				failed_at: failed_at || null,
				gave_up_at: gave_up_at || null,
				requested_hint_at: requested_hint_at || null,
				response: response || null,
				last_hint: _.isNumber(last_hint) ? last_hint : null,
			});
			this.trial_id = id;
			return id;
		} catch (e) {
			LOGGER.error(e);
			return null;
		}
	}

	async update(obj) {
		try {
			await this.controller.enqueue(ALIAS.UPDATE, {
				id: async () => {
					const id = await this.getId();
					return id;
				},
				...obj,
			});
			for (let key in obj) {
				this[key] = obj[key];
			}
		} catch (e) {
			LOGGER.error(e);
		}
	}

	async setPassed() {
		if (!this.passed_at) {
			try {
				await this.update({
					passed_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setFailed() {
		if (!this.failed_at) {
			try {
				await this.update({
					failed_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setGaveUp() {
		if (!this.gave_up_at) {
			try {
				await this.update({
					gave_up_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setRequestedHint() {
		if (!this.requested_hint_at) {
			try {
				await this.update({
					requested_hint_at: Math.floor(Date.now() / 1000),
				});
			} catch (e) {
				LOGGER.error(e);
			}
		}
	}

	async setResponse(str) {
		try {
			await this.update({
				response: str,
			});
		} catch (e) {
			LOGGER.error(e);
		}
	}

	async setLastHint(num) {
		LOGGER.warn("lastHint", num);
		try {
			await this.update({
				last_hint: num,
			});
		} catch (e) {
			LOGGER.error(e);
		}
	}

	static get ALIAS() {
		return ALIAS;
	}
}
